import { DeepLink } from '../../types/DeepLink';
import HelpIcon from '@mui/icons-material/Help';
import { ReactNode } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@material-ui/core';
import { useStyles } from './customCard.style';

import { Content, InfoCard } from '@backstage/core-components';

interface CustomCardProps {
  title: string;
  subheader?: string;
  children: ReactNode;
  deepLink?: DeepLink;
  tooltip?: string;
  extraInfo?: string;
}

function CustomCard({
  title,
  subheader,
  children,
  deepLink,
  tooltip = '',
  extraInfo = '',
}: Readonly<CustomCardProps>) {
  const { cx, classes } = useStyles();

  return (
    <InfoCard
      title={
        <>
          {title}
          {tooltip !== '' ? (
            <Tooltip title={tooltip} arrow>
              <HelpIcon className={cx(classes.tooltip)} />
            </Tooltip>
          ) : (
            extraInfo !== '' && (
              <Typography variant="body2" className={cx(classes.extraInfo)}>
                {extraInfo}
              </Typography>
            )
          )}
        </>
      }
      subheader={subheader}
      deepLink={deepLink}
    >
      <Content>{children}</Content>
    </InfoCard>
  );
}

export { CustomCard };
